import { initTransitionGroup } from './_scrollAnimations';
import { initModdalLink } from './_modals';
import { DOM, classes } from '../const';
import { initShareBtn } from './_shareBtns';
import { initDropdown } from './_dropdowns';

const { isActive } = classes;

const { $hbody } = DOM;

const $$paginationBlocks = $('.js-pagination-block');

const initContent = ($parent, type) => {


  if (type === 'news') {
    $parent.find('.js-transition-group').each((i, el) => {
      initTransitionGroup($(el));
    });
    $parent.find('.js-modal-link').each((i, el) => {
      initModdalLink($(el));
    });
  } else if (type === 'jobs') {
    const $$shareBtns = $parent.find('.js-share-btn');
    const $$dropdowns = $parent.find('.js-dropdown');
    $$shareBtns.each((i, el) => {
      initShareBtn(el);
    });

    $$dropdowns.each((i, el) => {
      initDropdown($(el));
    });
  }

};

export const initPaginationBlock = ($el) => {
  const url = $el.data('url');

  const max = $el.data('max');

  const type = $el.data('type');

  let current = $el.data('current');

  const $content = $('.js-pagination-content');

  const $pageCurr = $el.find('.js-pagination-cur');

  const $loader = type === 'jobs' ? $('.backup__js-jobs-search-loader') : $('.js-pagination-loader');

  const $prevBtn = $el.find('.js-pagination-btn.js-pagination-btn-prev');

  const $nextBtn =  $el.find('.js-pagination-btn.js-pagination-btn-next');



  const doAjax = () => {
    $loader.addClass(isActive);


    $.ajax({
      method: 'GET',
      url,
      cache: false
    })
    .done(html => {
      $content.empty();

      $content.append(html);

      initContent($content, type);

      setTimeout(() => {
        $loader.removeClass(isActive);


        if (type === 'jobs') {
          const $targetElem = $el.closest('.js-search-tabcontent');
          $targetElem.animate({
            scrollTop: 0
          }, 500);
        } else {
          $hbody.animate({
            scrollTop: $el.offset().top - 20
          }, 500);
        }
      }, 300);
    })
    .fail(() => {
      setTimeout(() => {
        $loader.removeClass(isActive);
      }, 300);

    });

  };

  const move = num => {
    current += num;
    $pageCurr.text(current);

    if (current < max) {
      $nextBtn.removeClass('tx-inactive');
      $nextBtn.prop('disabled', false);
    } else {
      $nextBtn.addClass('tx-inactive');
      $nextBtn.prop('disabled', true);
    }

    if (current > 1) {
      $prevBtn.removeClass('tx-inactive');
      $prevBtn.prop('disabled', false);
    } else {
      $prevBtn.addClass('tx-inactive');
      $prevBtn.prop('disabled', true);
    }
    doAjax();
  };


  $nextBtn.click(event => {
    event.preventDefault();
    move(1);
  });

  $prevBtn.click(event => {
    event.preventDefault();
    move(-1);
  });
};

const paginationBlocks = () => {
  $$paginationBlocks.each((i, el) => {
    initPaginationBlock($(el));
  });
};

export default paginationBlocks;
